<template>
    <div id="modals-container">
        <ModalOverlay v-for="modal in modals" :key="modal.id" :modal="modal">
            <component :is="modal.component" :modal="modal"
                       v-bind="modal.componentAttrs"
                       v-on="modal.modalListeners"/>
        </ModalOverlay>
    </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, computed } from 'vue';
import { ModalState } from '@/core/modals/ModalState';

const ModalOverlay = defineAsyncComponent(() => import('@/project/modals/ModalOverlay.vue'));

const modals = computed(() => {
    return ModalState.modals;
});
</script>

<style lang="less" scoped>
#modals-container {
    position: absolute;
}
</style>
